import {Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, AfterViewChecked, ChangeDetectorRef, ElementRef, TemplateRef, ContentChild, Output, EventEmitter, AfterViewInit, ContentChildren} from '@angular/core';
import { AbsPaginatedGrid, TYPE_DONNEE } from 'src/app/app.models';
import * as XLSX from 'xlsx';
import { ColumnMode, DatatableComponent, SortDirection } from '@swimlane/ngx-datatable';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';

export enum ABW_MAT_DATATABLE_VIEWMODE {
  READONLY = 1,
  SELECTION = 2,
}

@Component({
    selector: 'abw-mat-datatable',
    templateUrl: './abw-mat-datatable.component.html',
    styleUrls: ['./abw-mat-datatable.component.scss'],
})
export class AbwMatDatatableComponent implements OnInit, OnChanges, AfterViewInit {
    filteredDatas: any[] = [];
    filteredText: string = null;
    isDatatableRefreshed = true;
    TYPE_DONNEE = TYPE_DONNEE;
    ColumnMode = ColumnMode;
    @Input() datas = new AbsPaginatedGrid();
    @Input() selected: any[] = [];
    @Input() primaryKey: any;
    @Input() columns: { prop: string, name: string, hasCustomHtml: boolean, typeDonnees: TYPE_DONNEE, width?: number, paramsColumn?: any }[] = [];
    @Input() viewMode = ABW_MAT_DATATABLE_VIEWMODE.READONLY;
    @Input() getRowClass = (row) => '';
    @Input() getCellClass = ({ row, column, value }) => '';
    @Output() onPageChanged = new EventEmitter<any>();
    @Output() onRowSelected = new EventEmitter<any>();
    @Output() onToggle = new EventEmitter<any>();
    @Output() onSelectionSubmit = new EventEmitter<any>();
    @ViewChild("table") public table: DatatableComponent;
    @ViewChild(MatSort) sort: MatSort;
    @ContentChildren('customHtml') customHtmlTemplate: TemplateRef<any>[];
    @ContentChild('actions') actionsTemplate: TemplateRef<any>;
    selection = new SelectionModel<any>(true, []);
    displayedColumns: string[] = [];
    dataSource: MatTableDataSource<any>;
    ABW_MAT_DATATABLE_VIEWMODE = ABW_MAT_DATATABLE_VIEWMODE;
    @Input() sortOrder: string = null;
    @Input() sortDirection: string = null;

    constructor(
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.datas && !!changes.datas.currentValue) {
            this.columns = this.datas.mAbsColumns.filter(column => column.mVisible).map(column => ({
                prop: column.mDatasource,
                name: column.mTitle || column.mDatasource,
                hasCustomHtml: column.mHasCustomHtml,
                typeDonnees: column.mTypeDonnees,
                width: column.width,
                paramsColumn: column.paramsColumn
            }));
            this.displayedColumns = this.columns.map(c => c.prop);
            
            this.dataSource = new MatTableDataSource(this.datas.mPagination.mDatas);
            if (!!this.sort) {
              this.dataSource.sort = this.sort;
            }
            this.doFilterDatas();
            window.dispatchEvent(new Event('resize'));
            this._cdf.detectChanges();
        }
        if (!!changes.selected && !!changes.selected.currentValue && !!changes.primaryKey && !!changes.primaryKey.currentValue) {
          const selectedPkValues = this.selected.map(d => d[this.primaryKey.DATASOURCE_COLUMN]);
          const datasourcePkValues = this.dataSource.data.filter(d => d[this.primaryKey.DATASOURCE_COLUMN] !== undefined && selectedPkValues.lastIndexOf(d[this.primaryKey.DATASOURCE_COLUMN]) > -1);
          this.selection.select(...datasourcePkValues);
        }
        if (!!changes.viewMode && changes.viewMode.currentValue !== undefined) {
          if (this.viewMode == ABW_MAT_DATATABLE_VIEWMODE.SELECTION) {
            this.displayedColumns.unshift('select');
          }
        }
    }

    ngAfterViewInit() {
      if (!!this.sort) {
        this.dataSource.sort = this.sort;
      }
    }

    doFilterDatas(_searchText?: string) {
        this.filteredText = _searchText;
        this.filteredDatas = this.datas.mPagination.mDatas;
        if (!!_searchText) {
            this.filteredDatas = this.filteredDatas.filter(row => {
                return Object.keys(row).filter(item => {
                    return !!row[item] && String(row[item]).toLowerCase().indexOf(_searchText.toLowerCase()) !== -1;
                }).length > 0;
            });
        }
    }
  
    doExportDatasAction() {
        if (!this.datas) { return; }
        const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.filteredDatas);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'Datasource.xlsx');
    }

    /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.datas.mPagination.mDatas.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.datas.mPagination.mDatas);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  doSubmitSelection() {
    this.onSelectionSubmit.emit(this.selection.selected);
  }

  onSelectRow(row: any) {
    if (this.viewMode == ABW_MAT_DATATABLE_VIEWMODE.SELECTION) {
      this.selection.toggle(row);
    }
  }
}